<template lang="pug">
v-container
  v-row
    v-col(cols="12")
      h1 {{task.name}}
      .d-inline-flex
        p Дата сдачи: {{task.notify_at | readableDateTime }}
        v-btn.error(small v-if="!timer").ml-2.mb-1 Задача просрочена
      p(v-if="timer") До сдачи осталось: {{timer}}
      v-card.mb-4(outlined).mb-4
        v-card-title Описание
        v-card-text
          p(v-if="!editDesc" @click=" isOwner ? editDesc = true : ''") {{ task.description }}
          v-textarea(v-model="editDescValue" v-if="editDesc" :placeholder="task.description")
          v-btn(v-if="editDesc" @click="resetDesc" text) Сбросить
          v-btn.ml-2(color="success" v-if="editDesc" @click="saveEditDesc") Сохранить
      v-card.mb-4(outlined)
        v-card-title  Подзадачи
        v-expansion-panels(no-gutters)
          v-expansion-panel
            v-expansion-panel-header(v-slot="{ open }")
              | Выполнено {{countDoneTask}} из {{addTasks.length}}
            v-expansion-panel-content
              v-card.mb-4(
                outlined
                v-for="addTask in addTasks"
                :key="addTask.id"
              )
                  v-card-title
                    v-checkbox(
                      :label="addTask.name"
                      v-model="addTaskStatus[addTask.id]"
                      @change="changeAddTaskStatus($event, addTask.id)"
                    )
                    span.font-weight-light.ml-2 {{addTask.notify_at}}
                  v-card-text {{addTask.description}}
              v-btn(
                @click="createTaskStatus = true"
              )
                v-icon mdi-plus
      task-attach(:taskId="this.$route.params.id" :mainFiles="[...task.images, ...task.documents]" :task="task")
      v-card.mb-4(outlined)
        v-card-title Исполнители
        v-card-text
          v-row(
            v-for="user in task.users"
            :key="user.id"
          )
            v-col(cols="10") {{ user.profile_name || user.username }}
            v-col(cols="2")
              v-btn(color="error" @click="detachUserTask(user.id)")
                v-icon mdi-minus
        v-card-actions
          v-dialog(
            dark
            width="450"
            v-model="addUserDialog"
          )
            template(v-slot:activator="{on}")
              v-btn(v-on="on")
                v-icon mdi-plus
            v-card
              v-card-title Выберите пользователя, которого хотите добавить
              v-card-text
                select-region(
                  v-model="addForm.region"
                  filled
                  label="Выберите регион исполнителя"
                )
                select-mun(
                  v-model="addForm.mun"
                  :region="addForm.region"
                  :disabled="!addForm.region"
                  filled
                  label="Выберите муниципалитет исполнителя"
                )
                select-my-user(
                  :mun="addForm.mun"
                  :region="addForm.region"
                  :disabled="!addForm.region"
                  multiple
                  v-model="addUser"
                  label="Назначьте исполнителя"
                  filled
                  return-object
                )
              v-card-actions
                v-btn(color="primary" @click="addUserDialog = false") Отменить
                v-btn(color="success" @click="addUserTask") Добавить

      v-card.mb-4(outlined)
        v-card-title Комментарий
        v-card-text(@click=" !isOwner ? editComment = true : ''")
          p(v-if="!editComment") {{ task.pivot_data  ? task.pivot_data.comment : 'Комментарий отсутствует'}}
          v-textarea(label="введите комментарий" v-if="editComment" filled :value="task.comment" v-model="newComment")
        v-card-actions
          v-btn(v-if="editComment" @click="resetComment" text) Сбросить
          v-btn(v-if="editComment" color="success" @click="addComment").ml-2 Сохранить
      v-btn.mb-2(
        v-if="task.status === 1"
        color="success"
        @click="doneTask(task.id)"
      ) Сдать задачу
      v-btn.mb-2(
        v-if="isOwner && task.status === 4"
        color="primary"
        v-on="on"
        @click="dialogCheck = !dialogCheck"
      ) Отправить на проверку
      v-btn.ml-2.mb-2(
        color="error"
        v-if="task.owner_id === user.id"
        @click="deleteTask(task.id)"
      )
        v-icon mdi-trash-can

  create-task(
    :value="createTaskStatus"
    @close="createTaskStatus = $event"
    :parent-id="task.id"
    @addNewTask="addTasks.unshift($event)"
  )
  v-dialog(
    dark
    width="450px"
    v-model="dialogCheck"
  )
    v-card(outlined)
      v-card-title Введите комментарий перед тем, как отправить на проверку исполнителю/исполнителям
      v-card-text
        v-text-field(
          v-model="commentCheck"
          label="Введите комментарий"
        )
      v-card-actions
        v-btn(
          @click="taskOnCheck(task.id)"
          color="success"
        ) Отправить
        v-btn.ml-2(
          @click="!dialogCheck"
          color="primary"
        ) Сбросить

  v-card(outlined)
    v-toolbar(flat color="accent").white--text
      div.d-flex.flex-grow-1
        p.title.mb-0.mr-auto {{task.owner_id === user.id ? "Чат с исполнителями" : "Чат с инциатором"}}
        v-btn.rounded.align-self-start(
          fab
          x-small
          @click="showChat = !showChat"
          color="primary"
        )
          v-icon {{ showChat ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
    v-expand-transition
      div(v-if="showChat")
        application-chat(
          :messages="messages"
        )
        .pa-2
          app-editor(v-model="form.text" placeholder="Введите ваше сообщение")
        v-divider
        .pa-2.d-flex(style="overflow-x:auto")
          Uploader(@upload="uploadFile($event)")
            template(#activator="{ loading }")
              v-btn.mr-4(
                :loading="loading"
                color="success"
                height="120px"
                width="120px"
              )
                .d-flex.flex-column
                  v-icon mdi-plus
                  span.caption Добавить файл
          Element(
            v-for="(file, index) in files"
            :key="index"
            :show-edit="false"
            show-actions
            :name="file.original_name"
            :url="file.url"
            @delete="files.splice(index, 1)"
          )
        v-divider
        .pa-2
          v-btn(
            @click="sendMessage"
            :dislabed="!form.text"
            color="success"
          ) Отправить

</template>
<script>
import Uploader from '@/components/core/Uploader.vue';
import TaskAttach from '../components/TaskAttachments.vue';
import FolderIcon from '@/components/icons/Folder.vue';
import { CRUDFolders } from '@/services/API/folder';
import { isImage } from '@/lib';
import { CRUDInternalChats, CRUDInternalChatMessages } from '@/services/API/_crud';
import { mapActions, mapGetters } from 'vuex';
import SelectMyUser from '@/components/inputs/SelectMyUser.vue';
import taskServices, { CRUDTasks } from '@/services/API/task';
import CreateTask from '../components/CreateSubTask.vue';
import Element from '@/components/icons/Element.vue';
import AppEditor from '@/components/AppEditor.vue';
import mixinDateTime from '@/mixins/mixinDateTime';
import ApplicationChat from '@/modules/Question/components/ApplicationChat.vue';
import SelectRegion from '@/components/inputs/SelectRegion.vue';
import SelectMun from '@/components/inputs/SelectMun.vue';

const DEFAULT_FORM  = {
  text:'',
  files: {
    images: [],
    documents: [],
  },
};

export default {
  components: {
    TaskAttach,
    CreateTask,
    Element,
    SelectMyUser,
    AppEditor,
    ApplicationChat,
    FolderIcon,
    Uploader,
    SelectRegion,
    SelectMun,
  },
  mixins: [mixinDateTime],
  data() {
    return {
      editComment: false,
      editDesc: false,
      editDescValue: '',

      timer: '0:00',
      currentDate: new Date(),

      dialogCheck: false,
      addUsers: [],
      commentCheck: '',
      task: {},
      addTasks: [],
      newComment: '',
      addUser: null,
      addUserDialog: false,
      createTaskStatus: false,
      addTaskStatus: [],
      dialog: false,
      countTaskStatus: null,
      showChat:false,
      chat: [],
      messages: [],
      files: [],
      form :{ ...DEFAULT_FORM },
      addForm: { region: '', mun: '' },
    };
  },
  computed: {
    ...mapGetters({
      cachedUser: 'cache/cachedUser',
      user: 'auth/getUser',
      isRegion: 'auth/isRegion',
      isMunicipality:'auth/isMunicipality',
      isSupport: 'auth/isSupport',
    }),
    getRegion() {
      return this.addForm.region;
    },
    getMun() {
      return this.addForm.mun;
    },
    placeholderForSelect() {
      if (this.isRegion) return 'Укажите один или несколько муниципалитетов, либо выберите конкретных пользователей';
      if (this.isMunicipality) return ' Укажите одного или нескольких пользователей';
      return 'Укажите регионы, муниципалитеты или пользователей';
    },
    isOwner() {
      return this.task.owner_id === this.user.id;
    },
    countDoneTask() {
      return this.addTasks.filter((el) => el.status === 4).length;
    },
  },
  watch: {
    currentDate() {
      this.timerForEndTask();
    },
    getRegion: {
      handler() {
        this.addForm.mun = null;
        this.addUser = null;
      },
    },
    getMun: {
      handler() {
        this.addUser = null;
      },
    },
  },
  async created() {
    setInterval(() => { this.currentDate = new Date(); }, 1000);
    await this.init();
  },
  methods: {
    ...mapActions({
      loadToCache: 'cache/loadToCache',
    }),
    // createFolder() {
    // },
    async fetchFolders() {
      try {
        const params = {
          'search[target_id]': this.task.id,
        };
        this.folders = await CRUDFolders.getAll(params);
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async init() {
      await this.fetchMainTask();
      await this.fetchAddTasks();
      await this.fetchInternalChat();
      await this.fetchInternalChatMessages();
      await this.fetchFolders();
    },
    timerForEndTask() {
      let diff = new Date(this.task.notify_at) - new Date(this.currentDate);
      if (diff <= 0) {
        this.timer = false;
      } else {
        diff = new Date(diff);
        this.timer = `${diff.getUTCFullYear() - 1970 ? String(diff.getUTCFullYear() - 1970, '.') : ''}${diff.getUTCMonth() ? String(diff.getUTCMonth(), '.') : ''}${diff.getUTCDate() - 1 ? String(diff.getUTCDate() - 1, '.') : ''} ${diff.getUTCHours() ? diff.getUTCHours() : ''}:${diff.getUTCMinutes()}:${diff.getUTCSeconds()}`;
      }
    },
    resetComment() {
      this.newComment = this.task.comment;
      this.editComment = false;
    },
    resetDesc() {
      this.editDesc = false;
      this.editDescValue = this.task.description || '';
    },
    async saveEditDesc() {
      try {
        await CRUDTasks.update(this.task.id, { 'name': this.task.name, 'description': this.editDescValue });
        this.task.description = this.editDescValue;
        this.editDesc = false;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async changeAddTaskStatus(event, id) {
      if (event) {
        await this.doneTask(id);
      } else {
        await this.taskOnCheck(id, 'on check');
      }
    },
    async fetchInternalChat() {
      try {
        const params = {
          'search[target_id]':  this.task.id,
          'search[type]:': 1,
        };
        const response = await CRUDInternalChats.getAll(params);
        const [chat] = response.data.data;
        this.chat = chat;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },

    async fetchInternalChatMessages() {
      try {
        const params = { 'search[internal_chat_id]': this.chat.id };
        const response = await CRUDInternalChatMessages.getAll({ 'expand': 'images, documents', ...params });
        this.messages = response.data.data;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },
    async fetchMainTask() {
      const { id } = this.$route.params;
      try {
        const params = {
          expand: 'images,documents,is_favorite,comment,notify_at,users',
        };
        const response = await CRUDTasks.get(id, params);
        this.task = response.data.data;
        this.editDescValue = this.task.description;
        this.newComment = this.task.pivot_data?.comment || '';
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },
    async fetchAddTasks() {
      try {
        const params = {
          'search[parent_id]': this.task.id,
          'expand': 'images,documents,users,comment,is_favorite',
        };
        const response = await CRUDTasks.getAll(params);

        this.addTasks = response.data.data.map((task) => {
          this.addTaskStatus[task.id] = task.status === 4 ? 1 : 0;
          return task;
        });
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async doneTask(id) {
      try {
        const index = this.addTasks.findIndex(({ id: _id }) => id === _id);
        await taskServices.doneTask(id);
        if (this.task.id !== id) this.addTasks[index].status = 4;
        this.$toast.success(`Задача ${id} Завершена`);
        if (this.task.id === id) this.$router.push('/tasks');
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async deleteTask(id) {
      try {
        await CRUDTasks.delete(id);
        this.addTasks = this.addTasks.filter(({ id: _id }) => id !== _id);
        this.$toast.success('Задача успешно удалена');
        this.$router.push('/tasks');
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async taskOnCheck(id, text) {
      try {
        const index = this.addTasks.findIndex(({ id: _id }) => id === _id);
        await taskServices.onCheck(id, this.commentCheck || text);
        this.$toast.success('Задача  отправлена на доработку');
        if (this.task.id !== id) this.addTasks[index].status = 1;
        if (this.task.id === id) this.$router.push('/tasks');
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async addUserTask() {
      const { id } = this.task;
      // await this.loadToCache({ key: CACHE_KEYS.users, ids: users });

      try {
        const usersIds = this.addUser.map((val) => val.id);
        await taskServices.attachUser(id, [...usersIds]);
        this.addUserDialog = false;
        await this.fetchMainTask();
        this.addUser = null;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async detachUserTask(user_id) {
      const { id } = this.task;
      try {
        await taskServices.detachUser(id, [user_id]);
        this.task.users = this.task.users.filter(({ id: _id }) => _id !== user_id);
        this.$toast.success('Пользователь  успешно откреплен');
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async addComment() {
      const { id } = this.task;

      try {
        await taskServices.pivotUpdate(id, false, this.newComment);
        this.editComment = false;
        await this.fetchMainTask();
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },
    uploadFile(file) {
      this.files.push(file);
      if (isImage(file.file_name)) {
        this.form.files.images.push(file.file_name);
      } else {
        this.form.files.documents.push(file.file_name);
      }
    },
    async sendMessage() {
      try {
        const params = {
          'internal_chat_id': this.chat.id,
          'text': this.form.text,
          'images': [
          ],
          'documents': [
          ],
        };
        params.images = this.form.files.images;
        params.documents = this.form.files.documents;

        const response = await CRUDInternalChatMessages.create({ 'expand': 'images, documents', ...params });
        this.messages.push(response.data.data);
        this.form = { ...DEFAULT_FORM };
        this.form.files = [];
        this.$toast.success('Сообщение отправлено');
      } catch (err) {
        this.$toast.error(err.response.data.result_message);
      }
    },
  },
};

</script>
<style scoped></style>
